import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PropertyItemInspectionService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('PropertyItemInspection');
	}

	loadNeedingApproval(): Observable<TooBig4Car.Logic.PropertyItemInspection[]> {
		return this.myBaseService.loadAll(this.url + '/NeedApproval');
	}
	approve(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemInspection> {
		return this.myBaseService.post(null, this.url + '/Approve/' + (id ?? ''), true);
	}

	get(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemInspection> {
		return this.myBaseService.get(id, this.url);
	}
	save(tempItem: TooBig4Car.Logic.PropertyItemInspection): Observable<TooBig4Car.Logic.PropertyItemInspection> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}

}

